import { Constants } from "../utils/constants"
import { api } from "./api"


export const uploadAttachment = async (file, setFile, cancelToken) => {
    return api.post(Constants.URL.upload, file, {
        headers: {
            "content-type": "multipart/form-data"
        },
        cancelToken: cancelToken.token,
        onUploadProgress: ({ loaded, total }) => {
            setFile((prevState) =>     
               ( {
                    isUploading: true,
                    isUploaded: false,
                    progress: prevState.progress = loaded / total * 100,
                    url: prevState.url
                })
            );
        }
    })
        .catch(error => {
            console.log(error)
        });
}